import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { AttachMoney, Calculate } from '@mui/icons-material';
import { LANDING_CONTAINER_MAX_WIDTH, landingSectionSpacing } from '@/constants/landingLayout';

type CondoPricingSectionProps = {
  onOpenCalculator: () => void;
};

export default function CondoPricingSection({ onOpenCalculator }: CondoPricingSectionProps) {
  return (
    <Box id="pricing" sx={{ ...landingSectionSpacing, bgcolor: 'background.default' }}>
      <Container maxWidth={LANDING_CONTAINER_MAX_WIDTH}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 2 }}>
            <AttachMoney sx={{ fontSize: 40, color: 'primary.main' }} />
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              Planos simples para transformar a gestão do seu condomínio
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '700px', mx: 'auto', fontSize: '1.1rem', mb: 2 }}>
            {`Pare de depender de mensagens espalhadas no WhatsApp para acompanhar o que acontece no condomínio.

              Com o V-Condo, sua equipe centraliza demandas, acompanha solicitações em tempo real e organiza a operação do condomínio em uma única plataforma, simples e eficiente.`}
          </Typography>
          <Box sx={{ maxWidth: '800px', mx: 'auto', mb: 4, p: 3, bgcolor: 'primary.main', borderRadius: 2, color: 'white' }}>
            <Typography variant="body2" sx={{ textAlign: 'center', color: 'white', fontWeight: 'medium' }}>
              {`Sem cobrança por usuário. Sem taxas escondidas. Escolha o plano ideal para o tamanho da sua operação e tenha previsibilidade nos custos.`}
            </Typography>
          </Box>
          <Button
            variant="contained"
            size="large"
            startIcon={<Calculate />}
            onClick={onOpenCalculator}
            sx={{
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              mb: 6,
            }}
          >
            Ver valores e simular plano
          </Button>
        </Box>
      </Container>
    </Box>
  );
}